import { z } from "zod";

export const optInActionSchema = z.object({
  nodeId: z.string(),
  optInId: z.string().min(1, "Please enter valid name"),
  isValid: z.boolean().default(true),
});

export type OptInActionSchema = z.infer<typeof optInActionSchema>;
